// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__nXg1d","layout__content":"Layout_layout__content__o66_V"};